module.exports = __webpack_public_path__ + "img/demo1.778a3e83.png";